import { Provider } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from './environment-config.interface';

/**
 * Provides the environment configuration for the application
 * @param config - The environment configuration object
 * @returns Provider for the environment configuration
 */
export function provideEnvironmentConfig(config: EnvironmentConfig): Provider {
  return {
    provide: ENV_CONFIG,
    useValue: config,
  };
}
